<template>
    <div class="profile-container container-fixed">
        <div class="row no-gutters">
            
            <div v-if="!games || games.length == 0" class="col-md-12 mb-2 text-center">
                <div v-if="!loadingBlockWars" class="intro-container">
                    {{ 'NO_GAMES_PLEASE_MAKE_ONE' | translate }}
                </div>
                <div v-else class="intro-container">
                    {{ 'LOADING_PLEASE_WAIT' | translate }}
                </div>
            </div>

            <div v-for="(game, index) in games" :key="index" class="col-12 col-sm-12 col-md-6 col-lg-4">
                <div class="blockwar-item">
                    <div class="row no-gutters mb-4">
                        <div class="col-12 text-center">
                            <div v-if="!game.isComplete && !game.winner" class="main-header">
                                {{ 'REWARD_POOL' | translate }} - {{ fromWei(game.rewardPool) }} NAS
                            </div>   
                            <div v-else-if="game.isComplete && game.winner" class="main-header winner">
                                {{ 'WOW' | translate }} {{ game.winner.substr(game.winner.length-4, 4) }} - {{ 'WON' | translate }} {{ fromWei(game.rewardPool) }} NAS
                            </div>                    
                        </div>
                    </div>
                    <div class="row mb-4">
                        <div class="col-4">
                            <header>
                                {{ 'OWNER' | translate }}
                            </header>
                            <div>
                                {{ game.owner.substr(game.owner.length-4, 4) }}
                            </div>
                        </div>
                        <div class="col-4">
                            <header>
                                {{ 'GRID_SIZE' | translate }}
                            </header>
                            <div>
                                {{ game.gridSize }}
                            </div>
                        </div>
                        <div class="col-4">
                            <header>
                                {{ 'STATUS' | translate }}
                            </header>
                            <div>
                                {{ game.isComplete ? 'Closed' : 'Open' }}
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4">
                        <div class="col-4">
                            <header>
                                {{ 'PLAYER_ALLOWANCE' | translate }}
                            </header>
                            <div>
                                {{ game.playerAllowance }}
                            </div>
                        </div>
                        <div class="col-4">
                            <header>
                                {{ 'PRICE_TO_PLAY' | translate }}
                            </header>
                            <div>
                                {{ game.price }} NAS
                            </div>
                        </div>
                        <div class="col-4">
                            <header>
                                {{ 'COMPLETED' | translate }}
                            </header>
                            <div>
                                {{ Math.round(game.blocksPlayed / game.gridSize * 100) }} %
                            </div>
                        </div>
                    </div>
                    <div class="row pt-2">
                        <div class="col-12 text-center">
                            <button v-if="!game.isComplete" @click="goToRoute('game', game.id)" class="btn btn-primary">
                                {{ 'PLAY' | translate }}
                            </button>
                            <button v-else @click="goToRoute('game', game.id)" class="btn btn-secondary">
                                {{ 'VIEW' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import BlockHead from "../components/BlockHead";
import { contractAddress, nebPay, neb } from "../util/nebulas";

export default {
    name: 'About',
    components: { BlockHead },
    computed: {
        ...mapGetters({
            address: 'getAddress',
            games: 'getUserGames',
            pendingTransaction: 'getPendingTransaction'
        })    
    },
    created () {},
    methods: {
       
        fromWei (amount) {
            return neb.fromBasic(amount, "nas").toNumber();  
        },
        
        goToRoute (_name, _id) {

            if (name == 'game') {
                this.$store.commit('setGame', { id: _id });             
            } 

            this.$router.push({ name: _name, params: { id: _id }});

        }
    }
}
</script>

<style scoped lang="less">
@bgAccentColor: #3F4353;

.profile-container {
    padding: 0 10px 20px;
    color: #fff;

    .intro-container {
        padding: 40px;
        margin: 0 5px;
        background: @bgAccentColor;
        border-bottom: 3px solid #222532;
    }

    .blockhead-item {
        margin: 5px;
    }

    .generic-container {
        padding: 40px;
        margin: 0 5px;
        background: @bgAccentColor;
    }

    .blockwar-item {
        background: @bgAccentColor;
        border: 3px solid #222532;
        margin: 0 5px 12px;
        padding: 25px 0;
        text-align: center;

        .main-header {
            font-size: 20px;
            padding-bottom: 20px;
            border-bottom: 3px solid #222532;

            &.winner {
                color:#83a485;
            }
        }

        header {
            color: #96999C; 
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/Profile.vue